import LinearGradient from "./LinearGradient.js";
/**
 * All props pass through to `<LinearGradient {...props} />`
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function GradientSteelPurple(_ref) {
  let {
    from = '#65799B',
    to = '#5E2563',
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx(LinearGradient, {
    from: from,
    to: to,
    ...restProps
  });
}